import { useState, useRef, useEffect } from "react";

export default function ServiceDetailPerform() {
    const galleryRef = useRef(null);
    const [inView, setInView] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
        const el = galleryRef.current;
        if (!el || inView) return;

        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
            timeoutRef.current = setTimeout(() => {
            setInView(true);
            }, 500); 
        }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 

        return () => {
        window.removeEventListener("scroll", handleScroll);
        clearTimeout(timeoutRef.current); 
        };
    }, [inView]);

  return (
    <>
    <section className="detailserv-perform">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-12">
                    <div className="line-heading">
                        <div ref={galleryRef} className={`lineeffect ${inView ? "showline" : ""}`}></div>
                        <span>Performance</span>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="serv-perform-head">
                        <h4 className="heading">Strength Meets Sophistication</h4>
                        <p>Our millwork is engineered for structural integrity and lasting beauty. Every detail balances durability with refinement.</p>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="serv-perform-list">
                        <p>Find out more</p>
                        <ul>
                            <li><span>01</span> Precision joinery for structural and visual integrity.</li>
                            <li><span>02</span> Smooth integration with modular systems and flooring.</li>
                            <li><span>03</span> Wide selection of veneers, laminates and engineered woods.</li>
                            <li><span>04</span> Durable finishes that resist wear and are easy to maintain.</li>
                            <li><span>05</span> Tailored acoustic or MEP-friendly solutions on request.</li>
                            <li><span>06</span> Perfect coordination between large-format panels and fine detailing.</li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
